import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import M from 'materialize-css';
import { Redirect } from 'react-router-dom';
import Functions from '../../api/Functions';
import CircleLoader from '../loaders/CircleLoader';
import { useFirestore } from 'react-redux-firebase';

const InvalidateEntries = (props) => {
  const { auth } = props;
  const firestore = useFirestore();
  const [loading, setLoading] = useState(false);
  const [contestIds, setContestIds] = useState([]);
  const [dayFrom, setDayFrom] = useState('');
  const [dayTo, setDayTo] = useState('');
  const [contests, setContests] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [entriesBatches, setEntriesBatches] = useState([]);
  const [backup, setBackup] = useState(null);
  const batchSize = 5000;

  useEffect(() => getContests(firestore), [firestore]);

  useEffect(() => {
    var elems = document.querySelectorAll('select');
    M.FormSelect.init(elems, {});
  }, [contests]);

  const tryToLoadEntries = () => {
    if (contestIds.length === 0 || dayFrom === '' || dayTo === '') {
      M.toast({ html: 'Fill in all the fields' });
    } else {
      loadContestEntries();
    }
  };

  const loadContestEntries = () => {
    setLoading(true);
    firestore
      .collection('contestEntries')
      .where('idContest', 'in', contestIds)
      .where('day', '>=', dayFrom)
      .where('day', '<=', dayTo)
      .get()
      .then((snapshot) => {
        processEntries(snapshot);
        M.toast({ html: 'Entries loaded!' });
      })
      .catch((e) => M.toast({ html: e.message }))
      .finally(() => setLoading(false));
  };

  const processEntries = (snapshot) => {
    const contestEntries = snapshot.docs.map((doc) => doc.data());
    setTotalEntries(contestEntries.length);
    setBackup(JSON.stringify(contestEntries));
    setEntriesBatches(organizeInBatches(contestEntries));
  };

  const downloadBackUp = () => {
    var a = document.createElement('a');
    var file = new Blob([backup], { type: 'text/json;charset=utf-8' });
    a.href = URL.createObjectURL(file);
    a.download = 'entries.json';
    a.click();
  };

  const organizeInBatches = (array) => {
    const res = [];
    while (array.length) res.push(array.splice(0, batchSize));
    return res;
  };

  const getContests = (firestore) => {
    firestore
      .collection('contests')
      .get()
      .then((snapshot) => {
        const contests = snapshot.docs.map((doc) => doc.data());
        setContests(contests);
      })
      .catch((e) => M.toast({ html: e.message }));
  };

  const moveEntriesBatchToHistory = () => {
    setLoading(true);
    Functions.moveEntriesBatchToHistory({ entries: entriesBatches[0] })
      .then(() => {
        const newEntries = [...entriesBatches];
        newEntries.shift();
        setEntriesBatches(newEntries);
        M.toast({ html: newEntries.length === 0 ? 'Finished moving all batches' : 'Batch moved' });
      })
      .catch((e) => {
        M.toast({ html: e.message ? e.message : e });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderContestsSelect = () => (
    <div className="input-field">
      <select
        value=""
        onChange={(e) => {
          const id = e.target.value;
          if (!contestIds.includes(id)) {
            setContestIds((ids) => [...ids, id]);
          }
        }}>
        <option value="" disabled>
          Add a contest
        </option>
        {contests.map((contest) => renderContestOption(contest))}
      </select>
      <label>Contests</label>
      {renderContestIds()}
    </div>
  );

  const renderContestOption = (contest) => (
    <option key={contest.id} value={contest.id}>
      {`${contest.name || contest.nameCompany} (${contest.countryCode})`}
    </option>
  );

  const renderContestIds = () => {
    return <div style={{ whiteSpace: 'pre-line' }}>{contestIds.join('\n')}</div>;
  };

  const dateInput = ({ label, field, setField }) => {
    return (
      <div className="input-field col s12 m6 l6">
        <input id={label} type="text" value={field} onChange={(e) => setField(e.target.value)} />
        <label htmlFor={label} className="active">
          {label}
        </label>
      </div>
    );
  };

  const button = ({ label, onClick, disabled }) => {
    return (
      <div className="row">
        <button disabled={disabled} className="col s3 waves-effect waves-light btn-small" onClick={onClick}>
          {label}
        </button>
      </div>
    );
  };

  if (!auth.uid) {
    return <Redirect to="/signin" />;
  }

  return (
    <div className="container">
      <div className="title-section">Invalidate Entries</div>
      <br />
      {renderContestsSelect()}
      <h6>Enter date range (inclusive):</h6>
      <div className="row">
        {dateInput({ label: 'From (YYYYMMDD)', field: dayFrom, setField: setDayFrom })}
        {dateInput({ label: 'To (YYYYMMDD)', field: dayTo, setField: setDayTo })}
      </div>
      {button({ label: 'Load entries', onClick: tryToLoadEntries, disabled: loading })}
      {button({ label: 'Export entries json', onClick: downloadBackUp, disabled: loading || !backup })}
      {button({ label: 'Move entries batch', onClick: moveEntriesBatchToHistory, disabled: loading || entriesBatches.length === 0 })}
      <p>Total entries: {totalEntries}</p>
      <p>Remaining batches to move: {entriesBatches.length}</p>
      {loading && <CircleLoader />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(InvalidateEntries);
